<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-view-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 6a2 2 0 00-2-2H5a2 2 0 00-2 2v36a2 2 0 002 2h15a2 2 0 002-2V6zm23 21a2 2 0 00-2-2H27a2 2 0 00-2 2v15a2 2 0 002 2h16a2 2 0 002-2V27zM18 8H7v32h11V8zm11 21h12v11H29V29zM43 4a2 2 0 012 2v15a2 2 0 01-2 2H27a2 2 0 01-2-2V6a2 2 0 012-2h16zM29 8h12v11H29V8z"/></svg>
</template>
<script>

export default {
  name: 'IconViewAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
